import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_invoicing_optionService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { payload?: { id?: string, dimension?: string, value?: string, order?: number }, action?: string, skip?: number, take?: number, search?: string }): Promise<{ payload?: { id?: string, dimension?: string, value?: string, order?: number }[], success?: boolean, error?: any[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/functions/invoicing_option`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

